import React from 'react';

const GoogleLogin = ({ onSignIn, loading = false, loadingPhase = null, error = null }) => {
  const phaseMessage =
    loadingPhase === 'otp'
      ? 'Sending verification code…'
      : 'Signing in with Google…';

  return (
    <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-[#f5f7fa] to-[#c3cfe2] p-5 font-sans">
      <div className="bg-white rounded-2xl shadow-2xl p-12 max-w-[420px] w-full text-center relative overflow-hidden animate-slideInUp">
        {/* Gradient Bar */}
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#4285f4] via-[#34a853] via-[#fbbc05] to-[#ea4335]"></div>

        {loading && (
          <div
            className="absolute inset-0 z-20 flex flex-col items-center justify-center rounded-2xl bg-white/95 backdrop-blur-sm px-8"
            role="status"
            aria-live="polite"
          >
            <div className="w-11 h-11 border-4 border-gray-200 border-t-[#004aad] rounded-full animate-spin mb-5" />
            <p className="text-[#004aad] text-lg font-semibold">{phaseMessage}</p>
            <p className="text-gray-500 text-sm mt-2 max-w-[280px]">
              {loadingPhase === 'otp'
                ? 'Please wait while we email your one-time code.'
                : 'Securely connecting to your Google account.'}
            </p>
          </div>
        )}

        <div className="mb-10">
          <img
            src="/Atlas_big_bar.png"
            alt="Atlas Logo"
            className="h-[60px] w-auto mx-auto mb-6 block object-contain drop-shadow-md transition-transform duration-300 hover:scale-105"
          />
          <h1 className="text-[#1a1a1a] text-[32px] font-bold mb-3 tracking-tighter">Atlas Device Tracker</h1>
          <p className="text-[#5f6368] text-base mb-0 leading-normal">Sign in to access the dashboard and monitor your fleet</p>
        </div>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg relative mb-6 text-sm" role="alert">
            <strong className="font-bold">Error:</strong>
            <span className="block sm:inline ml-2">{error}</span>
          </div>
        )}

        <button
          className="flex items-center justify-center w-full py-4 px-6 bg-white border border-[#dadce0] rounded-xl text-base font-medium text-[#3c4043] cursor-pointer transition-all duration-300 mb-6 relative overflow-hidden hover:bg-[#f8f9fa] hover:border-[#4285f4] hover:shadow-lg hover:-translate-y-px disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none group"
          onClick={onSignIn}
          disabled={loading}
        >
          {loading ? (
            <div className="w-[22px] h-[22px] border-2 border-[#f3f3f3] border-t-[#4285f4] rounded-full animate-spin mr-3.5 flex-shrink-0" aria-hidden />
          ) : (
            <svg className="w-[22px] h-[22px] mr-3.5 flex-shrink-0" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
            </svg>
          )}
          <span>{loading ? phaseMessage : 'Sign in with Google'}</span>
        </button>
      </div>
    </div>
  );
};

export default GoogleLogin;
